import { useCallback, useEffect } from 'react';

import scrollbarSize from '../utils/dom';

const removeBodyScrolling = () => {
  const scrollingElement = (document.scrollingElement || document.body) as HTMLElement;

  scrollingElement.style.marginRight = `${scrollbarSize(true)}px`;
  scrollingElement.style.overflowY = 'hidden';
};

const restoreBodyScrolling = () => {
  const dialogs = Array.from(document.querySelectorAll('dialog'));
  const openDialogs = dialogs.filter((dialog) => dialog.open).length;
  const scrollingElement = (document.scrollingElement || document.body) as HTMLElement;

  if (!openDialogs) {
    scrollingElement.style.removeProperty('margin-right');
    scrollingElement.style.removeProperty('overflow-y');
  }
};

// shared variable between `useModal` usages
let originElement: HTMLElement | undefined;

export const useModal = () => {
  const restoreFocus = useCallback(() => {
    if (!originElement) {
      return;
    }

    const dialogs = Array.from(document.querySelectorAll('dialog'));
    const openDialogs = dialogs.filter((dialog) => dialog.open).length;

    // this was the last open dialog
    if (openDialogs === 0) {
      // restore focus when the focus is "lost" to the body element
      if (document.activeElement === document.body) {
        originElement.focus();
      }

      // always clear the originElement, or it will be set to a wrong element for future modals
      originElement = undefined;
    }
  }, []);

  useEffect(() => {
    return () => {
      restoreBodyScrolling();
      restoreFocus();
    };
  }, [restoreFocus]);

  const handleOpen = useCallback(() => {
    if (!originElement) {
      originElement = document.activeElement as HTMLElement;
    }

    removeBodyScrolling();
  }, []);

  const handleClose = useCallback(() => {
    restoreFocus();
    restoreBodyScrolling();
  }, [restoreFocus]);

  return { handleOpen, handleClose };
};
